import { render, staticRenderFns } from "./EcocardioDatiEditComponent.vue?vue&type=template&id=6f996e24"
import script from "./EcocardioDatiEditComponent.vue?vue&type=script&lang=js"
export * from "./EcocardioDatiEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports